import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlantList } from 'src/app/Modules/idms/components/plant-manager/models/plant-manager.model';
import { PlantmanagerService } from 'src/app/Modules/idms/components/plant-manager/services/plantmanager.service';
import { CalculationType } from 'src/app/Modules/informate/enums/calculation-type.enum';
import { ToolOutput } from 'src/app/Modules/informate/models/calculationModels';
import { DataService } from 'src/app/services/data.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-tool-selection',
    templateUrl: './tool-selection.component.html',
    styleUrls: ['./tool-selection.component.scss'],
    standalone: false
})
export class ToolSelectionComponent {
    @Input() toolsData: ToolOutput[];
    @Input() calculationType: CalculationType;
    @Input() selectedTaggedItem: PlantList;
    @Input() selectedTool: ToolOutput;
    @Input() selectedToolId: string;
    @Output() ResultEvent = new EventEmitter<any>();

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private dataService: DataService,
        private globalEmittersService: GlobalEmittersService,
        private modalService: NgbModal,
        private plantManagerservice: PlantmanagerService
    ) {}

    ngOnInit(): void {
        if (this.globalEmittersService.selectedTool) {
            this.selectedToolId = this.globalEmittersService.selectedTool.id; // this.selectedTool.id;
        }
    }

    Submit() {
        let id = this.selectedToolId;
        this.dataService.selectedToolId = id;
        let selectedToolInfo: ToolOutput = this.toolsData.find((x) => x.id == id);
        this.dataService.selectedToolName = selectedToolInfo.name;
        this.globalEmittersService.selectedTools.next(id);
        this.globalEmittersService.SelectedToolData.next(selectedToolInfo);
        this.globalEmittersService.toolsData.next(this.toolsData);
        this.ResultEvent.emit(true);
        this.ngbActiveModal.close();
    }

    closeClick() {
        if (!this.selectedToolId) {
            this.globalEmittersService.isToolSelected.next(false);
        }
        if (this.plantManagerservice.activeTaggedItem.taggedItemType == 'Joint') {
            this.modalService.dismissAll();
        } else {
            this.ngbActiveModal.close();
        }
    }
}
